import React from "react";
import { useLocation } from "react-router-dom";
import Footer from "../sections/Footer";
import PolicyPage from "../sections/PolicyPageES";
import SEO from "../components/SEO";
import StructuredData from "../components/StructuredData";
import { getOrganizationSchema, getBreadcrumbSchema } from "../utils/structuredData";

export default function PolicyES() {
    const location = useLocation();
    const baseUrl = process.env.REACT_APP_BASE_URL || 'https://livespainvisa.com';
    const currentUrl = `${baseUrl}${location.pathname}`;

    const seoData = {
        title: "Política de Privacidad - Live Spain Visa | Servicios Legales",
        description: "Política de Privacidad de Live Spain Visa Consulting. Conozca cómo recopilamos, usamos y protegemos su información personal cuando utiliza nuestros servicios de inmigración y visados.",
        keywords: "política de privacidad, protección de datos, RGPD, privacidad Live Spain Visa"
    };

    const breadcrumbSchema = getBreadcrumbSchema([
        { name: 'Inicio', url: baseUrl },
        { name: 'Política de Privacidad', url: currentUrl }
    ]);

    return (
        <>
            <SEO
                title={seoData.title}
                description={seoData.description}
                keywords={seoData.keywords}
                canonicalUrl={currentUrl}
                ogImage={`${baseUrl}/og-image.jpg`}
                lang="es"
                alternateLanguages={[
                    { lang: 'en', url: `${baseUrl}/policyEN/` },
                    { lang: 'es', url: `${baseUrl}/policyES/` }
                ]}
            />
            <StructuredData data={getOrganizationSchema()} id="organization-schema-policy-es" />
            <StructuredData data={breadcrumbSchema} id="breadcrumb-schema-policy-es" />
            <div>
                <PolicyPage/>
                <Footer/>
            </div>
        </>
    )
}
